import { type PaletteOptions } from '@mui/material/styles'
import { staticPalette } from '../../../../palette/static'
import { components } from '../../../../palette/dark/components'
import { blue } from '../../../../palette/dark/dark-blue'
import { dhlRed } from '../../../../palette/dark/dark-dhl-red'
import { green } from '../../../../palette/dark/dark-green'
import { grey } from '../../../../palette/dark/dark-grey'
import { opacity } from '../../../../palette/dark/dark-opacity'
import { orange } from '../../../../palette/dark/dark-orange'
import { postYellow } from '../../../../palette/dark/dark-post-yellow'
import { pure } from '../../../../palette/dark/dark-pure'
import { red } from '../../../../palette/dark/dark-red'

/**
 * PPL dark palette.
 *
 * Intentionally duplicated from the DHL dark palette as a starting point.
 * Replace imports/tokens here when PPL-specific colors are ready.
 */
const primary = {
  main: '#004b93',
  light: '#0263bf',
  dark: '#00376b',
  contrastText: pure.dark,
  states: {
    focus: '#99B7D4',
    hover: 'rgba(0, 75, 147, 0.08)',
  },
  notContained: '#004b93',
}
export const paletteDark: PaletteOptions = {
  mode: 'dark',
  grey,
  pure,
  static: staticPalette,
  background: {
    default: grey[100],
    paper: grey[200],
    brand: postYellow[500],
  },
  text: {
    primary: grey[800],
    secondary: grey[700],
    tertiary: grey[600],
    disabled: grey[500],
    dhlRed: dhlRed[600],
    error: red[600],
    warning: orange[600],
    success: green[600],
    informative: blue[600],
    inherit: 'inherit',
    placeholder: grey[400],
    icon: 'rgba(255, 255, 255, 0.5)',
  },
  primary,
  secondary: {
    main: postYellow[600],
    light: postYellow[200],
    dark: postYellow[800],
    contrastText: staticPalette.dark,
    states: {
      focus: postYellow[300],
      hover: postYellow[200],
    },
    notContained: postYellow[800],
  },
  alternative: {
    main: grey[250],
    dark: grey[400],
    light: grey[200],
    // JIRA-#DS-53 remove when old theme is gone, NOT NOW!
    contrast: pure.dark,
    contrastText: pure.dark,
    states: {
      focus: grey[400],
      hover: opacity.dark[250],
    },
  },
  dark: {
    main: grey[800],
    light: grey[300],
    dark: grey[900],
    contrastText: pure.light,
    states: {
      focus: grey[400],
      hover: opacity.dark[80],
    },
    notContained: grey[900],
  },
  light: {
    main: pure.light,
    light: pure.light,
    dark: pure.light,
    contrastText: grey[900],
    states: {
      focus: grey[400],
      hover: opacity.light[80],
    },
    notContained: pure.light,
  },
  info: {
    main: blue[600],
    light: blue[200],
    dark: blue[700],
    contrastText: pure.light,
    states: {
      focus: blue[300],
      hover: blue[200],
    },
    notContained: blue[700],
  },
  success: {
    main: green[600],
    dark: green[800],
    light: green[200],
    contrastText: pure.light,
    states: {
      focus: green[300],
      hover: green[200],
    },
    notContained: green[800],
  },
  warning: {
    main: orange[700],
    dark: orange[900],
    light: orange[200],
    contrastText: pure.light,
    states: {
      focus: orange[400],
      hover: orange[200],
    },
    notContained: orange[900],
  },
  error: {
    main: red[600],
    dark: red[700],
    light: red[200],
    contrastText: pure.light,
    states: {
      focus: red[300],
      hover: red[200],
    },
    notContained: red[700],
  },
  components: {
    ...components,
    navbar: {
      selected: 'rgba(0, 75, 147,0.10)',
      selectedHover: 'rgba(0, 75, 147,0.15)',
      contrast: pure.light,
    },
    pageHeader: {
      ...components.pageHeader,
      default: grey[200],
      color: {
        contrast: pure.light,
        default: pure.dark,
      },
    },
    tab: {
      selected: '#7FB0EA',
    },
    link: {
      contrast: '#7FB0EA',
    },
    bottomNavigation: {
      contrast: '#7FB0EA',
    },
  },

  // START overrule some items already in MUI (so we do not have to do this in components)
  action: {
    disabled: opacity.dark[250],
    disabledBackground: opacity.dark[50],
    disabledOpacity: 1,
    hover: opacity.dark[50],
  },
  divider: grey[300],
  // END overrule some items already in MUI (so we do not have to do this in components)
}
